<template>
	<div
		class="component media uk-relative uk-width-1-1"
		:class="{ 'image': !isGif, 'gif': isGif }"
		:id="'media-image-' + image.id"
		v-cloak
		>
		<!-- title -->
		<div class="text-container title" v-show="image.title">
			<h4 class="title">{{ image.title }}</h4>
		</div>

		<!-- description -->
		<div class="text-container description" v-show="image.description" v-html="image.description"></div>

		<a :name="'media-' + image.id"></a>

		<!-- media container -->
		<div class="media-container overflow-hidden relative">
			
			<!-- gif -->
			<div class="gif-container" v-show="isGif">
				
				<!-- video gif -->
				<div class="uk-flex-center uk-relative" v-if="image.encodedGif && !isApp">
					<div class="uk-flex uk-flex-center uk-flex-middle"  style="min-height: 200px">
							<Indicator v-show="!mediaLoaded" />
							<video
								ref="videoPlayer"
								v-show="mediaLoaded"
								:id="'media-video-gif-' + image.id"
								:data-url="image.encodedGif"
								loop
								playsinline
								webkit-playsinline
								muted
								autoplay
								preload="auto"
								style="width: 100%; max-height: 75vh;"
							>
								<source src type="video/mp4" />
							</video>
					</div>
				</div>
				<!-- // video gif -->

				<!-- default gif -->
				<div class="default gif relative" style="min-height: 200px" v-else>
					<a :href="setMediaUrl">
						<img style="width: auto; max-height: 550px;" :id="'media-gif-' + image.id" :data-url="image.url" />
					</a>
				</div>
			</div>
			<!-- // gif -->

			<!-- image -->
			<div class="image-container " v-show="!isGif">
				<!-- jpg/png image -->
				<div class="image">
					<a :href="setMediaUrl">
						<img
							:class="'media-image-' + image.id"
							:data-url="image.optimizedImage"
							:src="image.optimizedImagePlaceholder"
							class="uk-overflow-hidden"
							style="width: 100%; border-radius: 8px;"
						/>
					</a>
				</div>
				<!-- // jpg/png image -->
			</div>
			<!-- // image container -->

			<!-- explicit layer -->
			<div
				class="explicit-layer"
				:class="{ 'animate__animated animate__slideOutDown': explicitHidden }"
				:id="'explicit-layer-' + image.id"
				v-show="image.explicit"
				@click="hideExplicitLayer"
			>
				<div class="uk-position-center">
					<div class="uk-text-center">
						<span class="icon"><i class="fal fa-exclamation-circle fa-3x"></i></span>
						<h4>Waarschuwing: expliciete content</h4>
						<p>klikken = kijken op eigen risico</p>
					</div>
				</div>
			</div>
			<!-- // explicit layer -->

			<!-- overlay -->
			<div class="image-media-overlay" v-show="!mediaLoaded && !isGif">
				<div class="uk-position-center">
					<div class="uk-text-center">
						<LoadingIndicator />
					</div>
				</div>
			</div>
			<!-- overlay -->
			
		</div>
		<!-- // media container -->

		<!-- progress -->
		<div class="progress" v-show="!mediaLoaded && isGif">
			<div :style="{ width: progress + '%' }" class="bar"></div>
		</div>
		<!-- // progress -->
	
		<!-- image footer -->
		<div class="uk-flex uk-flex-middle uk-margin-bottom" style="max-height: 50px">
			<div class="uk-width-auto text-align-right">
				<span href="javascript:void(0)" class="uk-navbar-item uk-padding-small" style="padding-left: 0; padding-right: 0;">				
				<up-vote 
					v-show="showUpVote"
					ref="voting" 
					:element-id="image.id"
					:up-votes="image.votes.up"
					:show-up-vote="true"
					:show-down-vote="false"
					:show-tally-vote="false"
					:nav-bar-item="false"
				/>
				</span>
			</div>
			<div style="width: 15px"></div>
			<div class="uk-width-auto text-align-left" v-show="showComments">
				<!--<comments-modal 
					:total-comments="image.totalComments" 
					url="/async/comments?id={{ elementId }}"
					:js-variables="image.jsVariables"
					:nav-bar-item="true"
					>
				</comments-modal>-->
			</div>		
			<div class="uk-width-expand"></div>	
			<div class="uk-width-auto uk-text-light"></div>
		</div>	
	
		<div id="image-comments-container-{{ image.id }}"></div>
			
	</div>
</template>

<script>
import LoadingIndicator from './LoadingIndicator.vue'
import UpVote from './UpVote.vue'
import CommentsLoader from './CommentsLoader.vue'

export default {
	components: {
		LoadingIndicator,
		UpVote,
		CommentsLoader
	},	
	props: {
		index: Number,
		image: Object,
		entry: Object,
		options: Object,
		showComments: {
			type: Boolean,
			default: false
		},
		showUpVote: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			isRedactie: false,
			isEncodingServer: false,
			explicitHidden: false,
			isGif: null,
			mediaLoaded: false,
			progress: 0,
			comments: null,
			request: null,
			totalComments: 0,
			commentsLoaded: false,
			commentsIndicator: false,
			votes: {
				up: 0,
				down: 0,
				tally: 0,
			},
			videoObserver: null
		};
	},
	computed: {
		isApp: function () {
			return false;
		},
		setMediaUrl: function () {
			return "javascript:void(0)"
		},
	},
	mounted() {
		this.$logger("app/components/media-component-image/mounted/" + this.image.id);

		var component = this;
		var element = component.$el;
		var elementId = component.image.id;

		// Update component data
		component.isGif = (component.image.mimeType == "image/gif") ? true : false;
		component.totalComments = component.image.totalComments;
		component.votes.up = component.image.votes.up;
		component.votes.down = component.image.votes.down;
		component.votes.tally = component.image.votes.tally;

		// Add observers
		if ("IntersectionObserver" in window) {
			
			// Lazy load the image or video/gif
			if(component.options.lazy) {
	
				// Create observer for lazy elements
				const elementObserver = new IntersectionObserver((entries, elObserver) => {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							if (component.image.mimeType == "image/gif") {
								component.loadGif();
							} else {
								component.loadImage();
							}
	
							// remove observer
							elObserver.unobserve(element);
						}
					});
				});
	
				elementObserver.observe(element);
			} else {
				if (component.image.mimeType == "image/gif") {
					component.loadGif(); 
				} else {
					component.loadImage();
				}
			}	
			
			// Observer for pause/autoplay
			if(component.isGif && component.image.encodedGif) {

				const options = {
					root: null,
					rootMargin: '-30% 0% -30% 0%',
					threshold: 0.5
				};
				
				var videoElement = component.$refs.videoPlayer;
				
				const videoObserver = new IntersectionObserver((entries) => {
					entries.forEach(entry => {
						if (entry.isIntersecting) { 
							if (videoElement && videoElement.paused) {
								videoElement.play()
									.catch((error) => {
										console.error('Failed to play video:', error);
									});
							}
						} else {
							
							if (videoElement && !videoElement.paused) {
								videoElement.pause();
							}
						}
					});
				}, options);
				
				videoObserver.observe(videoElement);
			}
		}
	},
	methods: {
		hideExplicitLayer: function () {
			this.explicitHidden = true;
		},
		loadImage: function (component) {
			//this.$logger("app/components/media-component-image/loadImage/" + this.image.id);

			var component = this;
			var elementId = component.image.id;
			var element = component.$el;

			// Grab image el
			var imageElement = document.getElementsByClassName(
				"media-image-" + elementId
			)[0];

			if (imageElement) {
				// Download image
				var request = new XMLHttpRequest();

				request.onprogress = function (e) {
					if (e.lengthComputable) {
						component.progress = (e.loaded / e.total) * 100;

						console.log(component.progress)
						if (component.progress >= 100) {
							component.mediaLoaded = true;
						}
					}
				};

				request.onload = function () {
					imageElement.setAttribute("src", imageElement.dataset.url);
				};

				request.onloadend = function () {
					component.mediaLoaded = true;
				};

				request.open("GET", imageElement.dataset.url, true);
				request.overrideMimeType("text/plain; charset=x-user-defined");
				request.send(null);
			}
		},

		loadGif: function () {
			this.$logger("app/components/media-component-image/loadGif/" + this.image.id);

			var component = this;
			var elementId = component.image.id;
			var element = component.$el;
			
			// Grab image el
			var mediaElement, sourceElement;
			var videoElement = document.getElementById(
				"media-video-gif-" + elementId
			);
			var gifElement = document.getElementById("media-gif-" + elementId);

			if (videoElement && typeof videoElement != "undefined") {
				mediaElement = videoElement;
				sourceElement = videoElement.childNodes[0];
			} else if (gifElement && typeof gifElement != "undefined") {
				mediaElement = gifElement;
				sourceElement = gifElement;
			}

			if (mediaElement) {
				// Download image
				var request = new XMLHttpRequest();

				request.onprogress = function (e) {
					if (e.lengthComputable) {
						component.progress = (e.loaded / e.total) * 100;

						if (component.progress >= 100) {
							component.loaded = true;
						}
					}
				};

				request.onload = function () {
					sourceElement.setAttribute("src", mediaElement.dataset.url);
				};

				request.onloadend = function () {
					component.mediaLoaded = true;

					if (videoElement) {
						videoElement.load();
					}
				};

				request.open("GET", mediaElement.dataset.url, true);
				request.overrideMimeType("text/plain; charset=x-user-defined");
				request.send(null);
			}
		},
	},
};
</script>

<style scoped>
.media-container {
	border-radius: 8px;
	background: #fbfbfb;
}
</style>
